// Completed cycles remain distinct internally for confirmation permissions and lifetime Count.
export const statusLabel = (status) => ({
  in_queue: 'ASSIGNED', done: 'ASSIGNED', assigned: 'ASSIGNED', replaced: 'REPLACED'
}[status] || status || '-')
export const statusColor = (status) => status === 'replaced' ? 'danger' : 'primary'
